//console handleRemoveGallery  handleRemoveRsvp
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteGallery, deleteMusic, saveProfile, selectPresetMusic, uploadMusic } from '../../../redux/reducers/profileSlice';
import CropperCom from './CropperCom';
import inputErrors from '../../helpers/validation'
import Progress from './Progress';
import { useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Loader from '../../helpers/Loader';
import Switch from "react-switch";
import ImageAlbum from './ImageAlbum';
import fileToBase64 from '../../helpers/fileToBase64';
import { snackbarContext } from '../../helpers/Snakbar';


const EXTRA_DETAILS_FIELDS = [
    "preWeddingLink",
];

const ExtraDetails = ({ onBack, onNext }) => {
    const setStateSnackbarContext = React.useContext(snackbarContext);
    const formRef = useRef(null);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { weddingData: profileData, loading } = useSelector((state) => state.profile)
    const { user } = useSelector((state) => state.auth)
    const previewAudioRef = useRef(null);
    const [selectedPresetId, setSelectedPresetId] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [showPhotoGallery, setShowPhotoGallery] = useState(false);
    const [previewPlayingId, setPreviewPlayingId] = useState(null);
    const [preWedding, setPreWedding] = useState(false)
    const [musicDiv, setmusicDiv] = useState(false)
    const [rsvpDiv, setrsvpDiv] = useState(false)
    const [showRsvpDialog, setShowRsvpDialog] = useState(false);
    const [errors, setErrors] = useState({})
    const [isSubmitting, setSubmitting] = useState(false);
    const [showCropper, setShowCropper] = useState(false)
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [showalbum, setShowAlbum] = useState(false);
    const [open, setOpen] = useState(false)
    const [enabledGallery,setenabledGallery]=useState(false)
    const [values, setValues] = useState({
        preWeddingLink: "",
    })
    const [music, setMusic] = useState({
        enabled: true,
        mode: "preset", // "preset" | "upload"
        presetId: null,
        audioUrl: ""
    });

    const [rsvpData, setRsvpData] = useState({
        heading: "",
        subHeading:"",
        contacts: [
            { name: "", phone: "" }
        ]
    });

    const handleAddContact = () => {
        if (rsvpData.contacts.length >= 5) return;

        setRsvpData({
            ...rsvpData,
            contacts: [...rsvpData.contacts, { name: "", phone: "" }]
        });
    };

    const handleRemoveContact = (index) => {
        const updated = rsvpData.contacts.filter((_, i) => i !== index);

        setRsvpData({
            ...rsvpData,
            contacts: updated
        });
    };

    const handleContactChange = (index, field, value) => {
        const updated = rsvpData.contacts.map((contact, i) =>
            i === index ? { ...contact, [field]: value } : contact
        );

        setRsvpData({
            ...rsvpData,
            contacts: updated
        });
    };

  



    const [uploadedMusic, setUploadedMusic] = useState({
        name: "",
        url: "",
        publicId: ""
    });




    const handleSubmit = (e) => {
        e.preventDefault()
         const validationErrors = inputErrors(
               values,
              EXTRA_DETAILS_FIELDS
           ); 

if (rsvpDiv) {

    // Heading is required
    if (!rsvpData.heading || rsvpData.heading.trim() === "") {
        validationErrors.rsvp = "Please enter an RSVP heading";
    }

    // Heading max length
    else if (rsvpData.heading.trim().length > 30) {
        validationErrors.rsvp =
            "Heading cannot be more than 30 characters";
    }

    // Validate only contacts that have a name
    const validContacts = rsvpData.contacts.filter(
        (c) => c.name && c.name.trim() !== ""
    );

    if (validContacts.length > 0) {

        for (let i = 0; i < validContacts.length; i++) {

            const contact = validContacts[i];

            // Name validation
            if (contact.name.trim().length > 30) {
                validationErrors.rsvp =
                    `Name ${i + 1} is too long (max 50 characters)`;
                break;
            }

            // Phone length
            if (contact.phone && contact.phone.length > 20) {
                validationErrors.rsvp =
                    `Phone ${i + 1} is too long`;
                break;
            }

            // Phone format
            if (
                contact.phone &&
                !/^[0-9+()\-\s]*$/.test(contact.phone)
            ) {
                validationErrors.rsvp =
                    `Phone ${i + 1} contains invalid characters`;
                break;
            }
        }
    }
}

        setErrors(validationErrors)
        setSubmitting(true)
    }


    useEffect(() => {
        if (isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {

                savedata()
            } else {
                formRef.current.scrollIntoView({ behavior: "smooth" });
            }

        }
    }, [isSubmitting, errors])


    const savedata = () => {
        setSubmitting(false)

        // 🔥 STOP preview music on submit
        stopPreviewAudio();

       let rsvpPayload = null;

if (rsvpDiv) {
    const validContacts = rsvpData.contacts.filter(
        (c) => c.name.trim() !== ""
    );

    rsvpPayload = {
       heading: rsvpData.heading || "",
        subHeading: rsvpData.subHeading || "",
        contacts: validContacts,
    };
}
     
      
        const updatedValues = {
            ...values,
             preWeddingLink: preWedding ? values.preWeddingLink : "",
            rsvp: rsvpPayload,
            // music:music
        };
        dispatch(saveProfile({ values: updatedValues, onNext, lastStep: true, setIsDialogOpen, navigate, setStateSnackbarContext }))
    }


    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    }
    const handleCropper = () => setShowCropper(prevValue => !prevValue)
    const handleAlbum = () => setShowAlbum(prevValue => !prevValue)
   
   
    useEffect(() => {
        setValues({ ...profileData })

        if(profileData?.footerImages && profileData.footerImages.length>0){
            setShowPhotoGallery(true)
        }

        if(profileData && profileData.preWeddingLink){
              setPreWedding(true)
        }

        if (profileData?.rsvp && profileData.rsvp.heading) {

    // RSVP exists → enable the section
    setrsvpDiv(true);

    setRsvpData({
        heading: profileData.rsvp.heading || "",
        subHeading: profileData.rsvp.subHeading || "",

        contacts: profileData.rsvp.contacts?.length
            ? profileData.rsvp.contacts.map(c => ({
                name: c.name || "",
                phone: c.phone || ""
            }))
            : [{ name: "", phone: "" }]
    });

} else {

    // No RSVP → disable the section
    setrsvpDiv(false);

    setRsvpData({
        heading: "",
        subHeading: "",
        contacts: [{ name: "", phone: "" }]
    });
}

    }, [profileData])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (!profileData?.music) return;

        // Enable music section if music exists
        setmusicDiv(profileData.music.enabled);

        // Uploaded music
        if (profileData.music.type === "upload" && profileData.music.audio?.url) {
            setMusic({
                enabled: true,
                mode: "upload",
                presetId: null,
                audioUrl: profileData.music.audio.url
            });

            setUploadedMusic({
                name: profileData.music.audio.fileName,
                url: profileData.music.audio.url,
                publicId: profileData.music.audio.publicId
            });
        }

        // Preset music
        if (profileData.music.type === "preset" && profileData.music.presetId) {
            setMusic({
                enabled: true,
                mode: "preset",
                presetId: profileData.music.presetId,
                audioUrl: ""
            });

            setSelectedPresetId(profileData.music.presetId);
        }
    }, [profileData]);

    useEffect(() => {
        return () => {
            if (previewAudioRef.current) {
                previewAudioRef.current.pause();
                previewAudioRef.current.currentTime = 0;
                previewAudioRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden && previewAudioRef.current) {
                previewAudioRef.current.pause();
                previewAudioRef.current.currentTime = 0;
                previewAudioRef.current = null;
                setPreviewPlayingId(null);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    const stopPreviewAudio = () => {
        if (previewAudioRef.current) {
            previewAudioRef.current.pause();
            previewAudioRef.current.currentTime = 0;
            previewAudioRef.current = null;
        }
        setPreviewPlayingId(null);
    };

    const sendWhatsAppMessage = (userCode) => {
        const phoneNumber = "+919326150846"; // Replace with your WhatsApp number
        const message = encodeURIComponent(`Hello, I want to add my pre-wedding video. My order id is: ${userCode}`);
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(whatsappURL, "_blank");
    };



    const handleViewDetails = () => {
        // navigate(`/${user&&user.userCode}`) 
        window.open(`/private/preview/${user && user.userCode}`, '_blank');
        setIsDialogOpen(false);
    };

    const handleCreateEvent = () => {
        // Redirect to create events page
        navigate("/event/new")
        setIsDialogOpen(false);
    };


    if (loading) {
        return <Loader />
    }

    const presetMusic = [
        {
            id: "Track_1",
            name: "Track 1",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881841/aamantran%20tracks%20assets/track_1_new_mijzcq.mp3",
        },
        {
            id: "Track_2",
            name: "Track 2",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881841/aamantran%20tracks%20assets/track_2_new_pcjsch.mp3",
        },
        {
            id: "Track_3",
            name: "Track 3",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881840/aamantran%20tracks%20assets/track_3_new_eshlqp.mp3",
        },
        {
            id: "Track_4",
            name: "Track 4",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881840/aamantran%20tracks%20assets/track_4_new_gvlyun.mp3",
        },
        {
            id: "Track_5",
            name: "Track 5",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881840/aamantran%20tracks%20assets/track_5_new_m950a3.mp3",
        },
        {
            id: "Track_6",
            name: "Track 6",
            url: "https://res.cloudinary.com/depixc8dq/video/upload/v1776881839/aamantran%20tracks%20assets/track_6_new_b8y13o.mp3",
        },
    ]



    const togglePreview = (track) => {
        // If same track is playing → pause it
        if (previewPlayingId === track.id) {
            previewAudioRef.current.pause();
            previewAudioRef.current.currentTime = 0;
            previewAudioRef.current = null;
            setPreviewPlayingId(null);
            return;
        }

        // Stop any previous preview
        if (previewAudioRef.current) {
            previewAudioRef.current.pause();
            previewAudioRef.current.currentTime = 0;
        }

        // Play new preview
        const audio = new Audio(track.url);
        audio.volume = 0.7;
        audio.play().catch(() => { });
        previewAudioRef.current = audio;
        setPreviewPlayingId(track.id);

        // Auto-clear when audio ends
        audio.onended = () => {
            setPreviewPlayingId(null);
            previewAudioRef.current = null;
        };
    };

    const removeMusic = () => {
        setUploadedMusic({
            name: "",
            url: "",
            publicId: ""
        });

        setMusic({
            ...music,
            audioUrl: "",
            mode: "preset",
            enabled:false,
            presetId:null
        });
        setOpen(false)
        dispatch(deleteMusic({ setStateSnackbarContext }));
    };

     const handleRemoveGallery = () => {
        dispatch(deleteGallery({setStateSnackbarContext}))
        setenabledGallery(false)
        setShowPhotoGallery(false)
        
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGalleryClose = () => {
        setenabledGallery(false)
    }


    const handleMusicUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validation
        if (file.type !== "audio/mpeg") {
            setStateSnackbarContext(true,
                `Only MP3 files allowed`,
                "warning")
            // alert("Only MP3 files allowed");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            setStateSnackbarContext(true,
                `Max file size is 2MB`,
                "warning")
            // alert("Max file size is 2MB");
            return;
        }

        try {
            setUploading(true);

            const base64 = await fileToBase64(file);

            uploadMusicFunc({ file: base64, fileName: file.name })
        } catch (err) {
            alert("Upload failed");
        } finally {
            setUploading(false);
            e.target.value = "";
        }
    };

    const uploadMusicFunc = (payload) => {
        dispatch(uploadMusic({ payload, setStateSnackbarContext }))
    }

    const handlePresetClick = (track) => {

        if (music.mode === "upload") {
            setStateSnackbarContext(true, "You have already uploaded your own music. Please remove it first to choose from Aamantran library", "warning")
            // alert(
            //     "You have already uploaded your own music. Please remove it first to choose from Aamantran library."
            // );
            return;
        }

        if (!track.id) {
            return
        }

        // Optimistic UI (instant feedback)
        setSelectedPresetId(track.id);
        setMusic({
            enabled: true,
            mode: "preset",
            presetId: track.id,
            audioUrl: track.url,
        });

        // 🔥 Persist preset selection
        dispatch(
            selectPresetMusic({ presetId: track.id, url: track.url, setStateSnackbarContext })
        );

    };
 

    const handleGalleryToggle=(checked)=>{
        if(checked){
          setShowPhotoGallery(true)
          return;
        }else{
            setenabledGallery(true)
        }
       
    }

    const handleWhatsAppPrewedding = () => {
    if (user?.demoVersion) {
        setStateSnackbarContext(
            true,
            "Upgrade to send your pre-wedding video. We'll handle the rest!",
            "warning"
        );
        return;
    }

    sendWhatsAppMessage(user?.userCode);
};

    const handlePreweddingToggle=(checked)=>{
        setPreWedding(checked)
    }

    const handleRsvpToggle=(checked)=>{
        setrsvpDiv(checked)
    }

       const handleMusicToggle = (checked) => {
        // const checked = e.target.checked;
        // User is enabling → just open section
        if (checked) {
            setmusicDiv(true);
            return;
        } else {
            setOpen(true)
        }
    }
    return (
        <>
            {/* <Progress activeStep={4} demoVersion={user && user.demoVersion} /> */}
            <div className="form-screen">
                <div className="container mb-3">
                    <div className="row d-flex justify-content-center  flex-column align-items-center  mx-2">
                        <div className="col-lg-8 col-md-11 form-container">
                            <h3 className='form-heading'>ADD MORE TO YOUR INVITE</h3>
                            <form className='form-div' onSubmit={handleSubmit} ref={formRef}>
                             <div className={`condition-form-div`}>
                              <label> Photo Gallery </label>
                               <Switch
                                        checked={showPhotoGallery}
                                        onChange={handleGalleryToggle}
                                        onColor="#1636ff"
                                        offColor="#c9c9c9"
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        handleDiameter={22}
                                        height={26}
                                        width={46}
                                    />
                             </div>

                             {showPhotoGallery && <>
                                  <div className="gallery-container">
                                    <span className='gallery-helper'>Share your favorite moments with your guests</span>
                                    <button  className="gallery-btn" type="button"  onClick={handleAlbum} >Manage Photos</button>
                                  </div>
                             </>}


                                <div className="condition-form-div">
                                    <label> Prewedding video </label>
                                     <Switch
                                        checked={preWedding}
                                        onChange={handlePreweddingToggle}
                                        onColor="#1636ff"
                                        offColor="#c9c9c9"
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        handleDiameter={22}
                                        height={26}
                                        width={46}
                                    />
                                </div>
                                {preWedding && <>
                                     <span className='gallery-helper'>Share your love story with a beautiful pre-wedding video</span>
                                     <div className={errors.preWeddingLink ? "form-input-div-error" : "form-input-div"}>
                                                    <input type="text"
                                                        name="preWeddingLink"
                                                        value={values.preWeddingLink}
                                                        onChange={handleChange}
                                                        placeholder='Paste Your Link'
                                                        className={errors.preWeddingLink ? "form-input-field-error" : "form-input-field"}
                                                    />
                                                    <small> <b>(Add a YouTube link of your pre-wedding <i style={{ color: "red" }} className="fab fa-youtube"></i> )</b> </small>
                                                    <div className='error-wedding-div'>  {errors.preWeddingLink && (<small className="error-msg-wedding">{errors.preWeddingLink}</small>)}</div>
                                                </div>

                                                <span className='prewedding-divider'>Or</span>

                                                <button className='gallery-btn whatsapp-prewedding-button' type='button' onClick={handleWhatsAppPrewedding}>
                                                 {user?.demoVersion && (
        <i className="fa-solid fa-lock prewedding-lock-icon"></i>
    )}

{!user?.demoVersion && (
      <i className="fa-brands fa-whatsapp" ></i>
    )}
                                                Send via whatsapp</button>
                                                <p className='small-i'> (Send your video, we’ll handle the rest!)</p>
                                </>}
                

                                <div className='condition-form-div conditional-ep'>

                                    <label>Family Contact Details</label>
                                    <Switch
                                        checked={rsvpDiv}
                                        onChange={handleRsvpToggle}
                                        onColor="#1636ff"
                                        offColor="#c9c9c9"
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        handleDiameter={22}
                                        height={26}
                                        width={46}
                                    />
                                </div>
 {!rsvpDiv && (
    <p className="option-helper-text">
        (Share contact details of family members guests can reach out to)
    </p>
    )}


                                {rsvpDiv && <>

                                    <div className="rsvp-form-section">

                                        {/* Heading input */}
                                        <div className="form-input-div">
                                            <input
                                                type="text"
                                                value={rsvpData.heading}
                                                onChange={(e) =>
                                                    setRsvpData({ ...rsvpData, heading: e.target.value })
                                                }
                                                placeholder="Heading (Eg: With Regards/Contact/From)"
                                                className="form-input-field"
                                            />
                                        </div>

                                          <div className="form-input-div">
                                            <input
                                                type="text"
                                                value={rsvpData.subHeading}
                                                onChange={(e) =>
                                                    setRsvpData({ ...rsvpData, subHeading: e.target.value })
                                                }
                                                placeholder="Sub Heading Eg:(Family/Business Name)"
                                                className="form-input-field"
                                            />
                                        </div>
                                        <h6 className='family-contact-in-heading'>Add up to 5 family contacts</h6>
                                        
                                        {/* Contacts */}
                                        {rsvpData.contacts.map((contact, index) => (
                                            <div key={index} className="rsvp-contact-row">

                                                <input
                                                    type="text"
                                                    placeholder="Name"
                                                    value={contact.name}
                                                    onChange={(e) =>
                                                        handleContactChange(index, "name", e.target.value)
                                                    }
                                                />

                                                <input
                                                    type="text"
                                                    placeholder="Phone (optional)"
                                                    value={contact.phone}
                                                    onChange={(e) =>
                                                        handleContactChange(index, "phone", e.target.value)
                                                    }
                                                />

                                                <button
                                                    type="button"
                                                    className="remove-btn"
                                                    onClick={() => handleRemoveContact(index)}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}

                                        {/* Add button */}
                                        {rsvpData.contacts.length < 5 && (
                                            <button
                                                type="button"
                                                className="add-contact-btn"
                                                onClick={handleAddContact}
                                            >
                                                + Add More
                                            </button>
                                        )}
                                        {rsvpData.contacts.length >= 5 && (
                                            <small className="rsvp-limit-text">
                                                Maximum Limit Reached
                                            </small>
                                        )}
                                    </div>
                                    <div className='error-wedding-div'>  {errors.rsvp && (<small className="error-msg-wedding">{errors.rsvp}</small>)}</div>
                                </>}

                                <div className='condition-form-div conditional-ep'>
                                    <label >Add Background Music?  </label>
                                     <Switch
                                        checked={musicDiv}
                                        onChange={handleMusicToggle}
                                        onColor="#1636ff"
                                        offColor="#c9c9c9"
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        handleDiameter={22}
                                        height={26}
                                        width={46}
                                    />
                                </div>
                                {musicDiv && (<div className="music-section">
                                    <div
                                        className={`music-library-option ${music.mode === "preset" ? "active" : ""
                                            }`}
                                        onClick={handlePresetClick}
                                    >
                                        <div className="music-library-header">
                                            <i className="fa fa-music upload-music-icon" aria-hidden="true"></i>
                                            <span className="music-title">Choose from Aamantran Library</span>
                                            <input
                                                type="radio"
                                                checked={music.mode === "preset"}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    {music.mode === "preset" && (
                                        <div className="preset-music-grid">
                                            {presetMusic.map((track) => (
                                                <div key={track.id} className="preset-row">

                                                    {/* Radio select */}
                                                    <label className="preset-radio">
                                                        <input
                                                            type="radio"
                                                            checked={selectedPresetId === track.id}
                                                            onChange={() => handlePresetClick(track)}
                                                        />
                                                        <span>{track.name}</span>
                                                    </label>

                                                    {/* Play / Pause */}
                                                    <button
                                                        type="button"
                                                        className="preset-play-btn"
                                                        onClick={() => togglePreview(track)}
                                                    >
                                                        {previewPlayingId === track.id ? "⏸" : "▶"}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    <hr className="music-divider" />
                                    <div className="music-upload-section">

                                        {!uploadedMusic.url ? (
                                            <>
                                                {user.demoVersion ? <label className="upload-btn" onClick={() => setStateSnackbarContext(true, "Uploading your own music is not available in the trial.Please choose a track from the Aamantran library.", "warning")}>
                                                    <span className="upload-icon">⬆</span>
                                                    Upload your own music

                                                </label> : <label className="upload-btn">
                                                    <span className="upload-icon">⬆</span>
                                                    Upload your own music
                                                    <input
                                                        type="file"
                                                        accept="audio/mpeg"
                                                        hidden
                                                        onChange={handleMusicUpload}
                                                    />
                                                </label>}



                                                <p className="music-helper">
                                                    MP3 only • Max 2MB • 20–40 seconds recommended
                                                </p>
                                            </>
                                        ) : (
                                            <div className="uploaded-music-row">
                                                <span className="music-file-name">
                                                    🎵 {uploadedMusic.name}
                                                </span>

                                                <button
                                                    type="button"
                                                    className="remove-music-btn"
                                                    onClick={() => setOpen(true)}
                                                >
                                                    ✕
                                                </button>

                                            </div>
                                        )}
                                    </div>

                                </div>)}
                                <Dialog open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{'Remove background music?'}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            This action can't be undone.
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose}>Disagree</Button>
                                        <Button onClick={() => removeMusic()} autoFocus>
                                            Agree
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={enabledGallery}
                                    onClose={handleGalleryClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{'Remove Photo Gallery'}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                           All Photos will be deleted <br/>
                                            This action can't be undone.
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleGalleryClose}>Disagree</Button>
                                        <Button onClick={handleRemoveGallery} autoFocus>
                                            Agree
                                        </Button>
                                    </DialogActions>
                                </Dialog>





                                <div className='form-double-buttons'>
                                    <button type='button' onClick={onBack} >Back</button>
                                    <button type='submit'>Submit</button>
                                </div>
                            </form>
                            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                                <DialogTitle>Details Saved Successfully 🎉</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Next step: Add your wedding events and venue locations
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>

                                    <Button onClick={handleCreateEvent}>Create Events (Recommended)</Button>
                                    <Button onClick={handleViewDetails}>Preview Invite</Button>
                                    {/* <Button onClick={handleHome}>Get Back To Home Page</Button> */}
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>

            {showCropper && <CropperCom handleCropper={handleCropper} setValues={setValues} values={values} imageType="footerImage" />}
            {showalbum && <ImageAlbum handleAlbum={handleAlbum} />}
        </>
    )
}

export default ExtraDetails